import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, KeyRound, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  staff: any | null;
}

const ResetPasswordSystemDialog = ({ open, onOpenChange, staff }: Props) => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);

  if (!staff) return null;

  const handleReset = async () => {
    if (!password || password.length < 6) {
      toast.error("كلمة المرور يجب أن تكون 6 أحرف على الأقل");
      return;
    }
    setLoading(true);
    const { data, error } = await supabase.functions.invoke("manage-system-staff", {
      body: { action: "reset_password", staff_id: staff.id, new_password: password },
    });
    setLoading(false);
    if (error || data?.error) {
      toast.error(data?.error || error?.message || "خطأ");
      return;
    }
    toast.success("تم إعادة تعيين كلمة المرور بنجاح ✅");
    onOpenChange(false);
    setPassword("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" dir="rtl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-amber-500" />
            إعادة تعيين كلمة المرور
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            إعادة تعيين كلمة مرور <span className="font-bold text-foreground">{staff.full_name}</span> ({staff.email})
          </p>
          <div>
            <Label>كلمة المرور الجديدة *</Label>
            <div className="relative">
              <Input
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="******" dir="ltr" minLength={6}
              />
              <button type="button" className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" onClick={() => setShowPw(!showPw)}>
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <Button className="w-full" onClick={handleReset} disabled={loading || password.length < 6}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "تأكيد إعادة التعيين"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResetPasswordSystemDialog;
